import React, { useEffect, useState, useRef } from "react";
import useApp from "hooks/useApp";
import { Link, useNavigate } from "react-router-dom";
import styles from "../index.module.css";
import { Button, LayerBottom, Scroller } from "components";

const JoinHome = () => {
  const App = useApp();
  const navigate = useNavigate();
  const scroller = useRef();
  const [authorityLayer, setAuthorityLayer] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  let interval;

  const closeAuthorityLayer = () => {
    setAuthorityLayer(false);

    // [슬라이드팝업이 닫힌 후 setTime 함수가 시작되도록 수정. 20221123]
    interval = setInterval(() => {
      //console.log('setTime');
      if (!scroller.current) {
        clearInterval(interval);
        return;
      }
      const now = scroller.current.getCurrent();
      if (now < 5) {
        scroller.current.slideRight();
      } else {
        clearInterval(interval);
      }
    }, 5000);
  };

  const goNext = () => {
    if (interval) clearInterval(interval);
    navigate("agreement");
  };

  const callback = (n) => {
    setButtonDisabled(n !== 4);
  };

  useEffect(() => {
    App.setShowHeader(false);

    App.setShowNav(false);
    App.setMainClass("white");

    setTimeout(() => {
      setAuthorityLayer(true);
    }, 1000);

    /*	// setTime이관
    interval = setInterval(() => {
      if (!scroller.current) {
        clearInterval(interval)
        return
      }
      const now = scroller.current.getCurrent()
      if (now < 4) {
        scroller.current.slideRight()
      } else {
        clearInterval(interval)
      }
    }, 5000)
    */
  }, []);

  return (
    <div className="page">
      <div
        className="flex_1 padding center-cont px_0"
        style={{ paddingTop: "5rem" }}
      >
        <div className="slider">
          <Scroller
            ref={scroller}
            full={true}
            callback={callback}
            dotsStyle="tutorial-slide-dots"
          >
            <li className="flex-column justify_center">
              <h3 className="tutorial-tit">하나의 앱으로</h3>
              <h3 className="tutorial-tit">
                <b>내 정보를 한눈에!</b>
              </h3>
              <div className="tutorial-sub">
                <p className="tutorial-sub-tit">
                  내 자산 관리 어렵지 않아요!
                  <br />
                  쉽고 빠르게 회원가입하고
                  <br />
                  필요한 정보들만 쏙쏙!
                </p>
              </div>

              <div className={styles["member-intro-img01"]} />
            </li>
            <li className="flex-column justify_center">
              <h3 className="tutorial-tit">추천종목? 테마주?</h3>
              <h3 className="tutorial-tit">
                <b>따로 찾아보지 않아도 돼요!</b>
              </h3>
              <div className="tutorial-sub">
                <p className="tutorial-sub-tit">
                  만능 엔터테이너 모니,
                  <br />
                  일상 속 투자까지
                  <br />
                  간편하게 만들어 줄 수 있어요!
                </p>
              </div>

              <div className={styles["member-intro-img02"]} />
            </li>
            <li className="flex-column justify_center">
              <h3 className="tutorial-tit">내가 받을 수 있는</h3>
              <h3 className="tutorial-tit">
                <b>혜택은?</b>
              </h3>
              <div className="tutorial-sub">
                <p className="tutorial-sub-tit">
                  나이, 재직여부, 가족 수 등<br />
                  내 정보에 맞춘 정부지원금을
                  <br />
                  조회해 보세요.
                </p>
              </div>

              <div className={styles["member-intro-img03"]} />
            </li>
            <li className="flex-column justify_center">
              <h3 className="tutorial-tit">유사그룹과 비교 가능한</h3>
              <h3 className="tutorial-tit">
                <b>똑똑한 분석가</b>
              </h3>
              <div className="tutorial-sub">
                <p className="tutorial-sub-tit">
                  또래 평균과 비교해 보며
                  <br />
                  나의 위치를
                  <br />
                  파악해 보세요.
                </p>
              </div>

              <div className={styles["member-intro-img04"]} />
            </li>
          </Scroller>
          {/* <ul className="slider-dots dots-gray" style={{ marginTop: "14rem" }}>
						<li className="active" />
						<li />
						<li />
						<li />
					</ul> */}
        </div>
      </div>
      <div className="tutorial-btn-div">
        <Button
          className="btn btn--big"
          disabled={buttonDisabled}
          onClick={goNext}
        >
          시작하기
        </Button>
      </div>

      <AuthorityLayer show={authorityLayer} closeLayer={closeAuthorityLayer} />
    </div>
  );
};

const AuthorityLayer = ({ show, closeLayer }) => {
  return (
    <LayerBottom
      title="권한설정 안내"
      show={show}
      closeLayer={closeLayer}
      closeButton={false}
      outside={
        <div className="button-group">
          <Button className="btn btn--big btn-layer" onClick={closeLayer}>
            확인
          </Button>
        </div>
      }
    >
      <ul className="terms-list">
        <li>
          <div className="chk">
            <i className="" />
            <label htmlFor="check1">
              <span>
                <strong>[필수]</strong> 저장공간
              </span>
            </label>
          </div>
          <span className="terms-guide">
            기기 내 저장된 파일 및 기기의 외부 저장소 사용 공유 저장공간의
            컨텐츠 읽기
          </span>
        </li>
        <li>
          <div className="chk">
            <i className="" />
            <label htmlFor="check2">
              <span>
                <strong className="gray">[선택]</strong> 푸시알람
              </span>
            </label>
          </div>
          <span className="terms-guide">모니에서 제공하는 알림 수신</span>
        </li>
        <li>
          <div className="chk">
            <i className="" />
            <label htmlFor="check3">
              <span>
                <strong className="gray">[선택]</strong> Touch ID / Face ID
              </span>
            </label>
          </div>
          <span className="terms-guide">
            로그인 및 연동 등 서비스에서 사용자 인증을 위하여 이용
          </span>
        </li>
      </ul>
      <div className="terms-box mt_20">
        <p>
          ※ 선택적 접근 권한은 동의하지 않으셔도 앱 이용이 가능하며, 해당 기능
          이용 시 동의를 받습니다.
        </p>
        <p className="mt_20">※ 접근권한 변경방법 [설정-모니앱-권한 ON/OFF]</p>
      </div>
    </LayerBottom>
  );
};

export default JoinHome;
